import { createSelector } from "@reduxjs/toolkit";

import type { TUser } from "@/shared/services";
import { getAccount } from "@store/account/selectors";
import { getCustomVersion } from "@store/share-dialog/selectors";
import { getPageAndIntegrationVars } from "../get-page-and-integration-vars";
import { getDefaultValues } from "./get-default-values";
import { buildSenderData } from "@store/fast-versions/data/sender-data";

export const getFsValues = (user: TUser | undefined) =>
  createSelector(
    getPageAndIntegrationVars,
    getAccount,
    getCustomVersion,
    (fsVariables, account, version: any) => {
      const profileData = {
        org: {
          title: account?.title ?? "",
          website: account?.website ?? "",
          logo: account?.customization?.logo ?? "",
        },
        sender: buildSenderData(user),
      };
      if (version?.data) {
        const fsValues = getDefaultValues(fsVariables, profileData);

        return {
          ...fsValues,
          ...version?.data,
        };
      }

      return getDefaultValues(fsVariables, profileData);
    },
  );
